'use client';

import type { ReactNode } from 'react';
import { usePathname } from 'next/navigation';

export function NavigationContainer({ children }: { children: ReactNode }) {
  const pathname = usePathname();
  // Library puts its gutters outside the content width; review includes them inside.
  if (pathname === '/library' || pathname.startsWith('/library/')) {
    return <div className="px-5 sm:px-8"><div className="mx-auto max-w-6xl">{children}</div></div>;
  }
  return <div className={'mx-auto px-5 sm:px-8 ' + (pathname === '/upload' ? 'max-w-6xl' : 'max-w-5xl')}>{children}</div>;
}
